import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";

interface AnimeCardProps {
  anime: Anime;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link to={`/detail/${anime.id}`} className="group block">
      <div className="relative w-full aspect-[5/7] overflow-hidden rounded-lg bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title} 动漫封面`}
          title={`${anime.title} 在线观看 - 樱花动漫`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>

        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {anime.status}
        </span>

        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {anime.rating.toFixed(1)}
        </span>

        <div className="absolute bottom-0 left-0 right-0 translate-y-3 p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <p className="line-clamp-3 text-xs leading-relaxed text-background-100">{anime.description}</p>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="line-clamp-1 text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
          {anime.title}
        </h3>
        <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{anime.region}</span>
          <span className="text-background-400">·</span>
          <span>{anime.year}</span>
          <span className="ml-auto whitespace-nowrap text-accent-600">
            {anime.status === "已完结" ? "全" : ""}
            {anime.latestEpisode}集
          </span>
        </div>
      </div>
    </Link>
  );
}